import React, { useState } from 'react';
import { getCohorts } from '../../actions/Cohort/CohortAction';
import Constants from '../../Constants';
import Api from '../../Api';
import FlashMessages from '../Common/Messages/FlashMessages';
import { ModalContainer } from '../Common';
import { format } from 'date-fns';
import { useDispatch, useSelector } from 'react-redux';

const { formatDate } = Constants;
const api = new Api();

export const DeleteCohort = (props) => {
  const { cohort } = props;
  const casDetails = useSelector((state) => state.CasDetails?.casDetails) || [];
  const activeCasDetails = useSelector((state) => state.AppSession.activeCasDetails) || [];
  const [errorMessage, setErrorMessage] = useState();
  const [isBusy, setIsBusy] = useState(false);
  const dispatch = useDispatch();

  const onDeleteCohort = async ({ setOpened }) => {
    setErrorMessage();

    setIsBusy(true);
    try {
      const url = Constants.apiUrls.cohorts + '/' + cohort.id;
      const resp = await api.delData(url);
      resp.success ? dispatch(getCohorts(activeCasDetails.casId)) : void 0;
      setOpened(!resp.success);
    } catch (err) {
      console.error(err);
      setErrorMessage(err.response ? err.response.data.error : 'Cannot delete cohort');
    }
    setIsBusy(false);
  };

  const onCancel = ({ setOpened }) => {
    setOpened(false);
  };

  const hideFlashMessage = () => {
    setErrorMessage();
  };

  const getToggleButton = (opened, setOpened) => {
    const cohortDate = new Date(cohort.createdDate);
    return (
      <button
        aria-label={`Delete Cohort Name ${cohort.name} Created ${format(cohortDate, 'MMM dd, yyyy h:mm a')}`}
        title={`Delete Cohort Name ${cohort.name} Created ${format(cohortDate, 'MMM dd, yyyy h:mm a')}`}
        className="anchor-red fontSm-15 ref-blue-text"
        onClick={() => setOpened(true)}>
        <i className="far fa-trash-alt lsn-removelink mRight-5" aria-hidden />
        Delete
      </button>
    );
  };

  const getModalBody = () => {
    return (
      <React.Fragment>
        <FlashMessages
          close={hideFlashMessage}
          classNames="fl-delete-cohort"
          type="error"
          msg={errorMessage}
          open={!!errorMessage}
          scope="DeleteCohort"
        />
        <span className="show break-words">
          Are you sure you want to delete <b>{cohort.name}</b>?
        </span>
        <span className="show">You will not be able to undo this action.</span>
      </React.Fragment>
    );
  };

  return (
    <ModalContainer
      size="small"
      showCloseIcon
      title="Delete Cohort"
      text={getModalBody()}
      asToggleButtonFn={getToggleButton}
      buttons={[
        {
          label: 'Delete Cohort',
          onClick: onDeleteCohort,
          disabled: isBusy,
          dataTestId: 'delete-cohort-button',
        },
        {
          label: 'Go Back',
          onClick: onCancel,
          disabled: isBusy,
        },
      ]}
    />
  );
};

export default DeleteCohort;
